<style  scoped>



</style>

<template>

<header class="c-header u-absolute u-pos-tl u-marg-t-xxl u-fit-w u-align-center u-pad-x-w1of12 u-marg-t-md@sm u-align-left@sm js-header">
    
    <div class="c-header__container">
        <router-link to="/" class="c-header__logo t-link u-absolute u-pos-l u-inline-block u-relative@sm"><img src="../../assets/medias/images/RG-wordmark-reverse-bigger.svg" v-if="'news' !== $route.name"><img src="../../assets/medias/images/RG-wordmark.svg"  v-if="'news' === $route.name"></router-link>
        <ul class="c-header__container__list o-list--inline u-inline-block u-valign-bottom u-margin-xmmenu u-marg-b-xs u-hide@lg">
            <li class="c-header__item o-list__item" v-for="(item, index)  in content.nav.links" :class="{'u-marg-r-mds':((content.nav.links.length - 1)!=(index))}">
                <router-link :to="item.href"  class="c-header__item__link t-link t-text--base-bold t-text-ls--lg" :class="{'u-color--white':'news' !== $route.name,'u-color--brand-dark':'news' === $route.name}" active-class="is-active" exact>{{item.label}}</router-link>
            </li>
        </ul>
    </div>
</header>

</template>

<script>

export default {
    name: "app-header",
    props: {
        debug: {
            type: Boolean,
            default: !1
        },
        content: {
            type: Object,
            default: function() {}
        },
        color: {
            type: String,
            default: ""
        }
    },
    data: function() {
        return {
          colorinside:"clear"
    }

    },
    mounted: function()
    {
       //console.log("this.$route.name:"+this.color);
       "news" === this.$route.name?this.colorinside="dark":this.colorinside="clear"
    },
}

</script>



// WEBPACK FOOTER //
// src/components/app-header/index.vue